import React from 'react'
import AltNav from '../components/AltNav.js';

const Eventure = () => {
    return (
        <div>
            <AltNav />
            <div className='work-alt-header-bg'></div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('images/concert.jpg')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">EVENTURE</span>
                            <span class="stroke-text">EVENTURE</span>
                        </div>

                        <h2>PLAN YOUR NEXT EVENT</h2>
                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>Wire Frame for a concept ticketing app Eventure, meant for last minute adventures.</p>

                        <ul>
                            <li>Designed in figma</li>
                            <li>Uses dark color mode with dark blues and neon accents</li>
                            <li>I designed logo in Adobe Illustrator</li>
                            <li>Uses Figma Components for efficient reuse of elements</li>
                            <li>I liked the color scheme so much, I built my new portfolio (this one) based off of it</li>
                            <li>I plan to develop this app when I have more time</li>
                        </ul>
                        <a href='https://www.figma.com/design/1hvcqLTTQbo4py8qNlVx70/Eventure?node-id=1-2&p=f&t=DVFtXcM2VTPLhKl1-0' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                View Template
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='portfolio-images/ev.jpg' alt='Eventure Desktop View' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />




                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>Eventure is a conceptual wireframe for a spontaneous event discovery platform designed to help users find last-minute tickets to concerts, sports games, and live experiences. The app emphasizes bold visuals, an intuitive user flow, and a sense of adventure—making it easy for users to explore what's happening nearby on short notice. Though currently in the wireframing stage, Eventure showcases thoughtful UX design and a mobile-first layout tailored for fast, engaging browsing. I plan to fully develop the platform into a functional web app when I have more time to dedicate to front-end development and backend integration.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>

        </div>
    )
}

export default Eventure